<template>
  <div
    class="progress"
    :class="{'deleted': isDeleted}"
    v-tooltip="tooltip"
    v-if="!budgetCardProgressTemplate"
  >
    <div
      class="progress-bar progress--spent"
      :class="{'spent--red' : alternateColor}"
      :style="spentPercentStyle"
    ></div>
    <div
      class="progress-bar progress--assigned"
      :class="{'assigned--red' : alternateColor}"
      :style="assignedPercentStyle"
    ></div>
    <div
      class="progress-bar progress--total"
      :style="goalPercentStyle"
      :class="{'progress--total-disabled' : disabled, 'assigned--red' : alternateColor}"
    ></div>
  </div>
  <div
    class="Budgets-colorBar"
    v-else
  >
    <div
      class="Budgets-colorBar-block Budgets-colorBar-block--blue"
      :style="spentPercentStyle"
    ></div>
    <div
      class="Budgets-colorBar-block Budgets-colorBar-block--black"
      :style="assignedPercentStyle"
    ></div>
    <div
      class="Budgets-colorBar-block Budgets-colorBar-block--grey"
      :style="goalPercentStyle"
    ></div>
  </div>
</template>

<script>

export default {
  name: 'BudgetProgressBar',
  props: {
    spent: {
      type: [String, Number]
    },
    assigned: {
      type: [String, Number]
    },
    goal: {
      type: [String, Number]
    },
    available: {
      type: [String, Number]
    },
    budgetCardProgressTemplate: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean
    },
    isDeleted: {
      type: Boolean,
      default: false
    },
    alternateColor: {
      type: Boolean
    }
  },

  computed: {
    spentPercent () {
      if (!this.spent || !this.goal) return 0
      const spentPercent = (this.spent * 100) / this.goal
      return Math.abs(spentPercent)
    },
    assignedPercent () {
      if (!this.assigned || !this.goal) return 0
      const assignedPercent = (this.assigned * 100) / this.goal
      return Math.abs(this.spentPercent - assignedPercent)
    },

    goalPercent () {
      return Math.abs(100 - this.spentPercent - this.assignedPercent)
    },
    spentPercentStyle () {
      return {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: `${this.spentPercent}%`
      }
    },
    assignedPercentStyle () {
      return {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: `${this.assignedPercent}%`
      }
    },
    goalPercentStyle () {
      return {
        flexGrow: 0,
        flexShrink: 0,
        flexBasis: `${this.goalPercent}%`
      }
    },
    spentTooltipLabel () {
      return this.$t('budget_detail_budget_spent_tooltip', { spent: this.$options.filters.currency(this.spent, '€', 2, { symbolOnLeft: false, thousandsSeparator: '.', decimalSeparator: ',' }) })
    },
    availableTooltipLabel () {
      return this.$t('budget_detail_budget_available_tooltip', { available: this.$options.filters.currency(this.available, '€', 2, { symbolOnLeft: false, thousandsSeparator: '.', decimalSeparator: ',' }) })
    },
    tooltip () {
      if (this.spent >= 0 && this.available >= 0) {
        return {
          content: `<div class='d-flex flex-column'> <span>${this.spentTooltipLabel}</span><span>${this.availableTooltipLabel}</span></div>`,
          html: true

        }
      } else {
        return ''
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.progress {
  max-height: 4px;
  height: 4px;
  position: relative;
  bottom: 0;
  width: 100%!important;
  &.deleted {
    opacity: 0.6;
  }
}

.progress--assigned {
  background-color: var(--text-heading);
}
.progress--total {
  background-color: var(--gray-light);
}
.progress--total-disabled {
  background-color: rgba(140, 197, 241, 0.2);
}

.progress .spent--red {
  background-color: var(--semantic-negative-main);
}

.progress .assigned--red {
  background-color: var(--semantic-negative-main) !important;
}
</style>
